import { render, staticRenderFns } from "./signin.vue?vue&type=template&id=4fba1c5c&scoped=true&"
import script from "./signin.vue?vue&type=script&lang=ts&"
export * from "./signin.vue?vue&type=script&lang=ts&"
import style0 from "./signin.vue?vue&type=style&index=0&id=4fba1c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fba1c5c",
  null
  
)

export default component.exports